import React, {useEffect} from 'react';
import { NuqsAdapter } from 'nuqs/adapters/react'
import ReactGa from 'react-ga';
import {CssBaseline, CssVarsProvider} from '@mui/joy';
import theme from 'Theme';
import { HelmetProvider } from 'react-helmet-async';

import Router from './Route';

import 'react-toastify/dist/ReactToastify.css';
import {FlagsProvider} from 'store/provider/flagProvider';
import { ModalProvider } from 'store/provider/ModalProvider';
import QueryProvider from 'store/provider/QueryProvider';
import { UnsavedChangesProvider } from 'hooks/useUnsavedChanges';
import NotificationProvider from 'store/provider/NotificationProvider';

function App() {
	useEffect(() => {
		if (process.env.REACT_APP_NODE_ENV === 'production') ReactGa.initialize('UA-220083682-1');
	}, []);

	return (
		<HelmetProvider>
				<QueryProvider>
					<NuqsAdapter>
						<FlagsProvider>
							<NotificationProvider>
								<ModalProvider>
									<UnsavedChangesProvider>
										<CssVarsProvider theme={theme}>
										<CssBaseline />
													<Router />
											</CssVarsProvider>
									</UnsavedChangesProvider>
								</ModalProvider>
							</NotificationProvider>
						</FlagsProvider>
					</NuqsAdapter>
				</QueryProvider>
		</HelmetProvider>
	);
}

export default App;
